<template>
  <div>        
      <el-table
        :data="workOrderData.work_order_history"
        style="width: 100%">
        <el-table-column 
        prop="sale_date_changed"
        label="Date">
        </el-table-column>
        <el-table-column 
        prop="template_name"
        label="Garment Name">
            <template slot-scope="scope">
                {{scope.row.template_name}}
            </template>
        </el-table-column>
        <el-table-column 
        prop="appointment_date_changed"
        label="Promise Date">
        </el-table-column>
        <el-table-column 
        prop="appointment_type"
        label="Type">
            <template slot-scope="scope">
                {{scope.row.appointment_type === 0 ? 'Delivery' : 'Trial'}}
            </template>
        </el-table-column>
        <el-table-column
            fixed="right"
            label=""
            width="120">
            <template slot-scope="scope">
                <div style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                    <el-tooltip class="item" effect="dark" :content="'Download'">
                        <a @click="downloadWorkOrder(scope.row.id)" style="cursor: pointer;">
                        <i :class="$store.getters.getLoadingState ? 'el-icon-loading' : 'el-icon-download'"></i>
                        </a>
                    </el-tooltip>
                </div>                                        
            </template>
        </el-table-column>
    </el-table>

  </div>
</template>

<script>
export default {
    props: ['workOrderData', 'wo_index'],
    methods: {
        async downloadWorkOrder(workOrderId) {

            await this.$store.dispatch('fetchSingleWorkOrder', {
                wo_index: this.wo_index,
                work_order_id: workOrderId,
                sale_item_id_copy: this.workOrderData.sale_item_id,
                sale_item_sub_id_copy: this.workOrderData.sale_item_sub_id !== null ? this.workOrderData.sale_item_sub_id : 0,
                download_request: true,
                download_wo: true
            })

            setTimeout(() => {
                //this.$emit('swapTab')
            }, 1000);
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/WorkOrder/History.vue